export const firmKeys = {
  all: ['firms'] as const,
  details: (id: string) => [...firmKeys.all, id] as const,
  // Firestore-loaded matters (lightweight, for table display)
  mattersFirestore: (id: string) =>
    [...firmKeys.all, id, 'matters', 'firestore'] as const,
  // Cloud function-loaded matter with Finix data (for detail view)
  matterWithFinix: (firmId: string, matterId: string) =>
    [...firmKeys.all, firmId, 'matters', 'finix', matterId] as const,
  // Firestore transactions for a matter
  matterTransactions: (firmId: string, matterId: string) =>
    [...firmKeys.all, firmId, 'matters', matterId, 'transactions'] as const,
};
